export default __webpack_public_path__ + "static/media/hersheys.d1c69d0c.png";